export default "__VITE_ASSET__D1ZOFhAj__"